export const environment = {
  production: false,
  projectName: "WaddiDemo",
  dev: {
    REST_API_SERVER: "https://waddi.demo.api.testctsolution.it/api"
  },
  variables: {
    defaults: {}
  },
  customTranslationsDirectory: '/assets/custom-translations',
  defaultLang: 'it'
};
